// extracted by mini-css-extract-plugin
export default {"wrap":"RatingAbsentMessage_wrap__Vmzqt","title":"RatingAbsentMessage_title__RspNj","subtitle":"RatingAbsentMessage_subtitle__MUeeq"};